/* sucrase/dist/esm/parser/tokenizer/readWord.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.default = readWord;
    const base_1 = require("540718e523") /* ../traverser/base */;
    const charcodes_1 = require("22746c8ce8") /* ../util/charcodes */;
    const identifier_1 = require("364148c9f0") /* ../util/identifier */;
    const index_1 = require("bfb18d0576") /* ./index */;
    const readWordTree_1 = require("3d4c06ef43") /* ./readWordTree */;
    const types_1 = require("f0c35cbd76") /* ./types */;
    /**
     * Read an identifier, producing either a name token or matching on one of the existing keywords.
     * For performance, we pre-generate big decision tree that we traverse. Each node represents a
     * prefix and has 27 values, where the first value is the token or contextual token, if any (-1 if
     * not), and the other 26 values are the transitions to other nodes, or -1 to stop.
     */
    function readWord() {
        let treePos = 0;
        let code = 0;
        let pos = base_1.state.pos;
        while (pos < base_1.input.length) {
            code = base_1.input.charCodeAt(pos);
            if (code < charcodes_1.charCodes.lowercaseA || code > charcodes_1.charCodes.lowercaseZ) {
                break;
            }
            const next = readWordTree_1.READ_WORD_TREE[treePos + (code - charcodes_1.charCodes.lowercaseA) + 1];
            if (next === -1) {
                break;
            }
            else {
                treePos = next;
                pos++;
            }
        }
        const keywordValue = readWordTree_1.READ_WORD_TREE[treePos];
        if (keywordValue > -1 && !identifier_1.IS_IDENTIFIER_CHAR[code]) {
            base_1.state.pos = pos;
            if (keywordValue & 1) {
                (0, index_1.finishToken)(keywordValue >>> 1);
            }
            else {
                (0, index_1.finishToken)(types_1.TokenType.name, keywordValue >>> 1);
            }
            return;
        }
        while (pos < base_1.input.length) {
            const ch = base_1.input.charCodeAt(pos);
            if (identifier_1.IS_IDENTIFIER_CHAR[ch]) {
                pos++;
            }
            else if (ch === charcodes_1.charCodes.backslash) {
                // \u
                pos += 2;
                if (base_1.input.charCodeAt(pos) === charcodes_1.charCodes.leftCurlyBrace) {
                    while (pos < base_1.input.length && base_1.input.charCodeAt(pos) !== charcodes_1.charCodes.rightCurlyBrace) {
                        pos++;
                    }
                    pos++;
                }
            }
            else if (ch === charcodes_1.charCodes.atSign && base_1.input.charCodeAt(pos + 1) === charcodes_1.charCodes.atSign) {
                pos += 2;
            }
            else {
                break;
            }
        }
        base_1.state.pos = pos;
        (0, index_1.finishToken)(types_1.TokenType.name);
    }
}
